import React, { Component } from "react";

import "./DeBoskoffer.scss";

import intro from "../../Images/intro.png";
import text_frame from "../../Images/H3_tekstblok boskoffer.png";

import rotate_left from "../../Images/rotate_left.png";
import rotate_right from "../../Images/rotate_right.png";

import cacao from "../../Images/cacao.png";
import pijl from "../../Images/pijl.png";
import kom from "../../Images/kom.png";
import palosanto from "../../Images/palosanto.png";
import schaalkleurstof from "../../Images/schaalkleurstof.png";
import achiote from "../../Images/achiote.png"

import cacao_01 from "../../Images/CACAO_00.png";
import cacao_02 from "../../Images/CACAO_01.png";
import cacao_03 from "../../Images/CACAO_02.png";
import cacao_04 from "../../Images/CACAO_03.png";
import cacao_05 from "../../Images/CACAO_04.png";
import cacao_06 from "../../Images/CACAO_05.png";
import cacao_07 from "../../Images/CACAO_06.png";
import cacao_08 from "../../Images/CACAO_07.png";

import pijl_01 from "../../Images/PIJL_00.png";
import pijl_02 from "../../Images/PIJL_01.png";
import pijl_03 from "../../Images/PIJL_02.png";
import pijl_04 from "../../Images/PIJL_03.png";
import pijl_05 from "../../Images/PIJL_04.png";
import pijl_06 from "../../Images/PIJL_05.png";
import pijl_07 from "../../Images/PIJL_06.png";
import pijl_08 from "../../Images/PIJL_07.png";

import kom_01 from "../../Images/KOM_00.png";
import kom_02 from "../../Images/KOM_01.png";
import kom_03 from "../../Images/KOM_02.png";
import kom_04 from "../../Images/KOM_03.png";
import kom_05 from "../../Images/KOM_04.png";
import kom_06 from "../../Images/KOM_05.png";

import palosanto_01 from "../../Images/PALOSANTO_00.png";
import palosanto_02 from "../../Images/PALOSANTO_01.png";
import palosanto_03 from "../../Images/PALOSANTO_02.png";
import palosanto_04 from "../../Images/PALOSANTO_03.png";
import palosanto_05 from "../../Images/PALOSANTO_04.png";
import palosanto_06 from "../../Images/PALOSANTO_05.png";
import palosanto_07 from "../../Images/PALOSANTO_06.png";
import palosanto_08 from "../../Images/PALOSANTO_07.png";

import schaalkleurstof_01 from "../../Images/SCHAALKLEURSTOF_00.png";
import schaalkleurstof_02 from "../../Images/SCHAALKLEURSTOF_01.png";
import schaalkleurstof_03 from "../../Images/SCHAALKLEURSTOF_02.png";
import schaalkleurstof_04 from "../../Images/SCHAALKLEURSTOF_03.png";
import schaalkleurstof_05 from "../../Images/SCHAALKLEURSTOF_04.png";
import schaalkleurstof_06 from "../../Images/SCHAALKLEURSTOF_05.png";
import schaalkleurstof_07 from "../../Images/SCHAALKLEURSTOF_06.png";
import schaalkleurstof_08 from "../../Images/SCHAALKLEURSTOF_07.png";

import achiote_01 from "../../Images/ACHIOTE_B_1.png";
import achiote_02 from "../../Images/ACHIOTE_B_2.png";
import achiote_03 from "../../Images/ACHIOTE_B_3.png";
import achiote_04 from "../../Images/ACHIOTE_B_4.png";
import achiote_05 from "../../Images/ACHIOTE_B_5.png";
import achiote_06 from "../../Images/ACHIOTE_B_6.png";
import achiote_07 from "../../Images/ACHIOTE_B_7.png";
import achiote_08 from "../../Images/ACHIOTE_B_8.png";

class DeBoskoffer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
      object: {
        name: "Cacaobonen",
        image_small: cacao,
        images: [
          cacao_01,
          cacao_02,
          cacao_03,
          cacao_04,
          cacao_05,
          cacao_06,
          cacao_07,
          cacao_08
        ]
      },
      objects: [
        {
          name: "Cacaobonen",
          image_small: cacao,
          images: [
            cacao_01,
            cacao_02,
            cacao_03,
            cacao_04,
            cacao_05,
            cacao_06,
            cacao_07,
            cacao_08
          ]
        },
        {
          name: "Blaaspijp",
          image_small: pijl,
          images: [
            pijl_01,
            pijl_02,
            pijl_03,
            pijl_04,
            pijl_05,
            pijl_06,
            pijl_07,
            pijl_08
          ]
        },
        {
          name: "Mocahua aardewerk van de Kichwa gemeenschap",
          image_small: kom,
          images: [kom_01, kom_02, kom_03, kom_04, kom_05, kom_06]
        },
        {
          name: "Palo Santo",
          image_small: palosanto,
          images: [
            palosanto_01,
            palosanto_02,
            palosanto_03,
            palosanto_04,
            palosanto_05,
            palosanto_06,
            palosanto_07,
            palosanto_08
          ]
        },
        {
          name: "Verf van de Achiote boom",
          image_small: achiote,
          images: [
            achiote_01,
            achiote_02,
            achiote_03,
            achiote_04,
            achiote_05,
            achiote_06,
            achiote_07,
            achiote_08
          ]
        }
      ]
    };
  }
  render() {
    const { index, object, objects } = this.state;
    return (
      <div className="de-boskoffer">
        <div className="intro">
          <img src={intro} alt="Introductie" />
          <span>
            In onze boskoffer zitten heel wat voorwerpen. 
            Verdeel jullie in groepjes en zoek over 1 voorwerp informatie op. 
            Nadien kunnen jullie de voorwerpen aan elkaar voorstellen.
          </span>
        </div>
        <div className="object">
          <img
            className="rotate_left"
            src={rotate_left}
            alt="Draai naar links"
            onClick={() => {
              if (index === 0) {
                this.setState({
                  index: object.images.length - 1
                });
              } else {
                this.setState({
                  index: index - 1
                });
              }
            }}
          />
          <img
            className="object_big"
            src={object.images[index]}
            alt={object.name}
          />
          <img
            className="rotate_right"
            src={rotate_right}
            alt="Draai naar rechts"
            onClick={() => {
              if (index === 0) {
                this.setState({
                  index: object.images.length - 1
                });
              } else {
                this.setState({
                  index: index - 1
                });
              }
            }}
          />
        </div>
        <div className="object_name">
          <span
            style={{
              backgroundImage: `url("${text_frame}")`,
              backgroundRepeat: "round"
            }}
          >
            {object.name}
          </span>
        </div>
        <div className="objects">
          {objects.map(ob => {
            return (
              <img
                src={ob.image_small}
                className="object_small"
                alt={ob.name}
                onClick={() => {
                  this.setState({
                    object: ob,
                    index: 0
                  });
                }}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default DeBoskoffer;
